import { useApiQuery } from './useApiQuery';
import { notificationAlertsApi } from '../services/alertsApi';

export function useUnreadAlerts() {
  const { data: unreadCount, refetch } = useApiQuery(
    ['alerts', 'unread-count'],
    () => notificationAlertsApi.getUnreadCount(),
    {
      refetchInterval: 30000,
      staleTime: 15000,
    },
  );

  return {
    unreadCount: unreadCount ?? 0,
    refetch,
  };
}
